module.exports = __webpack_public_path__ + "img/round-language.e47bac6f.svg";